type TypedToken<T> = symbol & { readonly __type?: T };

function createToken<T>(name: string): TypedToken<T> {
	return Symbol(name) as TypedToken<T>;
}

export { createToken, type TypedToken };
